import { $rrj } from "@/utils/rrjutils";

export const getEmployeeUserId = () => $rrj.storage.get("_child_id");

export const isEmployee = () => !!getEmployeeUserId();

// 员工上下文是否包含指定权限；无上下文时返回 false（讲师由调用方单独放行）
export const hasPermission = (context, key) => {
  if (!context || !Array.isArray(context.permissions)) return false;
  return context.permissions.includes(key);
};
